import { create } from "zustand";

import { DimensionType } from "@/types/DimensionType";

type CreateNextActivitySheetState = {
  dimensionType: DimensionType;
  resetDimensionType: () => void;
  toggleDimensionType: () => void;
};

type ModalState = CreateNextActivitySheetState;

const initialDimensionType: DimensionType = "category";

export const useDimensionStore = create<ModalState>()((set) => ({
  dimensionType: initialDimensionType,
  resetDimensionType: () => set((state) => ({ ...state, dimensionType: initialDimensionType })),
  toggleDimensionType: () =>
    set((state) => ({ ...state, dimensionType: state.dimensionType === "feeling" ? "category" : "feeling" })),
}));
